/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import ReservationEvent from '../../event/ReservationEvent'
import TaskEvent from '../../event/TaskEvent'
import { TaskState } from '../state/TaskState'
import { TasksState } from '../state/TasksState'

class TaskCollectionStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List.of([])
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReservationEvent.hideDetail:
        return state.clear()

      case ReservationEvent.fetchTasks:
        return List(payload.tasks.map(model => new TaskState().merge(model)))

      case TaskEvent.updateTaskStatus:
        const task = payload.task

        return state.map(taskState => {
          if (taskState.id === task.id) {
            return taskState.set('status', task.status)
          }
          return taskState
        })
      case TaskEvent.onSearch:
        return List(payload.tasks.map(r => new TasksState(r)))

      default:
        return state
    }
  }
}

export default new TaskCollectionStore()
